// Debugging script for Film Development Wizard
console.log("Film Development Wizard Debugger loaded");

// Check for common issues when the page loads
document.addEventListener('DOMContentLoaded', function() {
  console.log("Debugger checking wizard structure...");
  
  // Check if all step elements exist
  for (let i = 1; i <= 6; i++) {
    const stepElement = document.getElementById(`step${i}`);
    if (!stepElement) {
      console.error(`Missing step element: step${i}`);
    } else {
      console.log(`Found step${i} element`);
    }
  }
  
  // Check step circles
  for (let i = 1; i <= 7; i++) {
    const circleElement = document.getElementById(`circle-${i}`);
    if (!circleElement) {
      console.error(`Missing circle element: circle-${i}`);
    } else {
      console.log(`Found circle-${i} element`);
    }
  }
  
  // Check for step 1 buttons
  const step1Buttons = document.querySelectorAll('#step1 button');
  console.log(`Found ${step1Buttons.length} buttons in step 1`);
  
  // Add click tracking to all wizard buttons
  document.querySelectorAll('.step button').forEach(button => {
    const originalOnclick = button.onclick;
    button.onclick = function(e) {
      console.log("Button clicked:", button.textContent.trim().split('\n')[0]);
      if (originalOnclick) {
        return originalOnclick.call(this, e);
      }
    };
  });
  
  // Monitor step changes
  const originalUpdateNavigation = window.updateNavigation;
  window.updateNavigation = function() {
    console.log("Updating navigation, current step:", currentStep);
    return originalUpdateNavigation.apply(this, arguments);
  };
  
  // Call fixStepTwoOptions after a delay to ensure all scripts are loaded
  setTimeout(checkWizardStatus, 500);
});

// Function to check the wizard's status and fix common issues
function checkWizardStatus() {
  console.log("Checking wizard status...");
  
  // Check if step 2 options are all disabled
  const step2Buttons = document.querySelectorAll('#step2 button');
  let allDisabled = true;
  
  step2Buttons.forEach(button => {
    if (!button.disabled) {
      allDisabled = false;
    }
  });
  
  if (allDisabled) {
    console.warn("All step 2 buttons are disabled, attempting to fix...");
    fixStepTwoOptions();
  }
}

// Add a global helper function to force activate a step
window.forceActivateStep = function(stepNumber) {
  console.log(`Manually activating step ${stepNumber}`);
  
  // Hide all steps
  document.querySelectorAll('.step').forEach(step => {
    step.classList.remove('active');
  });
  
  // Show the requested step
  const targetStep = document.getElementById(`step${stepNumber}`);
  if (targetStep) {
    targetStep.classList.add('active');
    window.currentStep = stepNumber;
    
    // Update navigation UI
    document.querySelectorAll('.step-circle').forEach((circle, index) => {
      circle.classList.toggle('active', index + 1 === stepNumber);
    });
    
    console.log(`Step ${stepNumber} activated successfully`);
  } else {
    console.error(`Unable to find step element: step${stepNumber}`);
  }
};

// Add a utility to show the current state
window.showWizardState = function() {
  console.log("Current step:", window.currentStep);
  console.log("User selections:", window.userSelections);
  console.log("Active elements:", document.querySelectorAll('.active').length);
  document.querySelectorAll('.active').forEach(el => {
    console.log("- Active element:", el.id);
  });
};

// Utility to manually fix step 2 options
window.fixStepTwoOptions = function() {
  return fixStepTwoOptions();
};

// Function to fix step 2 options that may be incorrectly disabled
function fixStepTwoOptions() {
  console.log("Fixing step 2 options...");
  
  // Get all step 2 buttons
  const step2Buttons = document.querySelectorAll('#step2 button');
  
  // Enable all buttons by default
  step2Buttons.forEach(button => {
    button.disabled = false;
    button.style.opacity = "1";
    button.style.cursor = "pointer";
    console.log(`Enabled button: ${button.textContent.trim()}`);
  });
  
  // If we have a film type selected, apply the correct disabling
  if (window.userSelections && window.userSelections.step1) {
    const filmType = window.userSelections.step1;
    console.log(`Selected film type: ${filmType}`);
    
    let availableTypes;
    switch(filmType) {
      case "35mm":
        availableTypes = ["Color (C-41)", "Black-and-White", "E-6 (Slide Film)", "Cross Processing", "ECN-2 (Cinematic Film)"];
        break;
      case "Disposable Camera":
        availableTypes = ["Color (C-41)", "Black-and-White"];
        break;
      case "120":
        availableTypes = ["Color (C-41)", "Black-and-White", "Cross Processing"];
        break;
      case "110":
      case "APS":
        availableTypes = ["Color (C-41)", "Black-and-White"];
        break;
      default:
        availableTypes = ["Color (C-41)", "Black-and-White"];
    }
    
    console.log(`Available types for ${filmType}:`, availableTypes);
    
    // Disable any buttons that shouldn't be available
    step2Buttons.forEach(button => {
      const processingType = button.getAttribute('data-processing-type') || button.textContent.trim();
      const isAvailable = availableTypes.includes(processingType);
      
      if (!isAvailable) {
        button.disabled = true;
        button.style.opacity = "0.5";
        button.style.cursor = "not-allowed";
        console.log(`Disabled button: ${processingType}`);
      }
    });
  } else {
    console.warn("No film type selected, all step 2 options enabled");
  }
  
  return "Step 2 options fixed!";
}

// Add a diagnostic and repair function for button click events
window.fixButtonClickEvents = function() {
  console.log("Diagnosing and fixing button click events...");
  
  // Get selected film type
  const rawFilmType = window.userSelections?.step1;
  
  console.log(`Film type for button fixing: ${rawFilmType}`);
  
  // Check step 2 buttons first (most common issue area)
  const step2Buttons = document.querySelectorAll('#step2 button');
  console.log(`Found ${step2Buttons.length} buttons in step 2`);
  
  // Determine available processing types based on film type
  let availableTypes = ["Color (C-41)", "Black-and-White"]; // Default
  if (rawFilmType === "35mm") {
    availableTypes = ["Color (C-41)", "Black-and-White", "E-6 (Slide Film)", "Cross Processing", "ECN-2 (Cinematic Film)"];
  } else if (rawFilmType === "Disposable Camera") {
    availableTypes = ["Color (C-41)", "Black-and-White"];
  } else if (rawFilmType === "120") {
    availableTypes = ["Color (C-41)", "Black-and-White", "Cross Processing"];
  } else if (rawFilmType === "110" || rawFilmType === "APS") {
    availableTypes = ["Color (C-41)", "Black-and-White"];
  }
  
  console.log("Available processing types:", availableTypes);
  
  let enabledCount = 0;
  
  step2Buttons.forEach(button => {
    const processingType = button.getAttribute('data-processing-type') || button.textContent.trim();
    console.log(`Checking button for ${processingType}`);
    
    // Reset event handlers on these buttons
    const originalOnclick = button.getAttribute('onclick');
    if (originalOnclick) {
      console.log(`Button had onclick: ${originalOnclick}`);
      
      // Create a new function to ensure it works
      button.onclick = function() {
        console.log(`Button clicked: ${processingType}`);
        nextStep(2, processingType);
      };
      
      console.log(`Fixed onclick for ${processingType}`);
    } else {
      console.log(`No onclick attribute found for ${processingType}, adding one`);
      button.onclick = function() {
        console.log(`Button clicked: ${processingType}`);
        nextStep(2, processingType);
      };
    }
    
    // Enable/disable based on film type if we have a selection
    if (rawFilmType) {
      const isAvailable = availableTypes.includes(processingType);
      button.disabled = !isAvailable;
      button.style.opacity = isAvailable ? "1" : "0.5";
      button.style.cursor = isAvailable ? "pointer" : "not-allowed";
      
      if (!isAvailable) {
        button.classList.add('disabled-option');
      } else {
        button.classList.remove('disabled-option');
        enabledCount++;
      }
      
      console.log(`Set ${processingType} availability to ${isAvailable}`);
    } else {
      // If no film type selected, ensure all buttons are enabled
      button.disabled = false;
      button.style.opacity = "1";
      button.style.cursor = "pointer";
      button.classList.remove('disabled-option');
      enabledCount++;
      console.log(`Ensuring ${processingType} is enabled (no film type selected)`);
    }
  });
  
  // Failsafe: if all buttons ended up disabled, force enable the primary ones
  if (enabledCount === 0 && step2Buttons.length > 0) {
    console.error("All buttons are disabled! Forcing primary options to be enabled");
    step2Buttons.forEach(button => {
      const processingType = button.getAttribute('data-processing-type');
      if (processingType === "Color (C-41)" || processingType === "Black-and-White") {
        button.disabled = false;
        button.style.opacity = "1";
        button.style.cursor = "pointer";
        button.classList.remove('disabled-option');
        console.log(`Forced ${processingType} to be enabled`);
      }
    });
  }
  
  // Also check if step 1 buttons need repair
  const step1Buttons = document.querySelectorAll('#step1 button');
  step1Buttons.forEach(button => {
    // Extract film type from button
    let filmType;
    if (button.textContent.includes('35mm')) {
      filmType = '35mm';
    } else if (button.textContent.includes('120')) {
      filmType = '120';
    } else if (button.textContent.includes('110')) {
      filmType = '110';
    } else if (button.textContent.includes('APS')) {
      filmType = 'APS';
    } else if (button.textContent.includes('Disposable')) {
      filmType = 'Disposable Camera';
    } else {
      filmType = button.textContent.split('\n')[0].trim();
    }
    
    button.onclick = function() {
      console.log("Step 1 button clicked:", filmType);
      nextStep(1, filmType);
    };
  });
  
  console.log("Button click events fixed!");
  return "Button click events have been repaired. Try clicking the buttons now.";
};

// Add a button to the debug panel to fix button click events
const debugPanel = document.getElementById('wizard-debug-panel');
if (debugPanel) {
  const fixButtonsButton = document.createElement('button');
  fixButtonsButton.textContent = 'Fix Button Clicks';
  fixButtonsButton.style.backgroundColor = '#4CAF50';
  fixButtonsButton.style.color = 'white';
  fixButtonsButton.onclick = window.fixButtonClickEvents;
  
  // Add to debug panel
  const buttonContainer = debugPanel.querySelector('div') || debugPanel;
  buttonContainer.appendChild(fixButtonsButton);
}

console.log("Film Development Wizard Debugger ready"); 